import React from 'react';
import {
  CallbackResult,
  RedirectBasedPayment,
} from '../common/GenericPayment/RedirectBasedPayment';

interface GenericFormProps {
  loading?: boolean;
  onPay: () => Promise<CallbackResult>;
  totalDue?: number | string;
  error?: string;
}

export const GenericForm = ({
  loading,
  onPay,
  totalDue,
  error,
}: GenericFormProps) => {
  return (
    <RedirectBasedPayment
      totalDue={totalDue}
      onClickCallback={onPay}
      loading={loading}
      error={error}
      dataTestId="generic-form-component"
    >
      The button below will take you to our third-party payment system to make
      your payment.
    </RedirectBasedPayment>
  );
};
